var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 68,
    viewBox: "0 0 88 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18.2143,
    width: 4,
    height: 35.2143,
    rx: 2,
    fill: "#FC7D57"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 4,
    height: 68,
    rx: 2,
    fill: "#FC7D57"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 1.21429,
    width: 4,
    height: 31.5714,
    rx: 2,
    fill: "#FC7D57"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 18.2143,
    width: 4,
    height: 49.7857,
    rx: 2,
    fill: "#FC7D57"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24.2857,
    width: 4,
    height: 29.1429,
    rx: 2,
    fill: "#FC7D57"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 1.21429,
    width: 4,
    height: 52.2143,
    rx: 2,
    fill: "#FC7D57"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 10.9286,
    width: 4,
    height: 32.7857,
    rx: 2,
    fill: "#FC7D57"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 32.7857,
    width: 4,
    height: 35.2143,
    rx: 2,
    fill: "#FC7D57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceSvg);
export default __webpack_public_path__ + "static/media/performanceSvg.820f3ce3a4ae27f635fe31a33659c85d.svg";
export { ForwardRef as ReactComponent };